<template>
    <div class="screen-container">
        <header class="screen-header">
            <span class="logo">
                <img src="/static/tp/logo.png" alt="" />
            </span>
            <span class="title">智慧供暖管理系统</span>
            <!-- 时间 -->
            <div class="title-right">
                <img src="/static/tp/sj.png" alt="" class="qiehuan" />
                <span class="datetime">{{ formattedTime }}</span>
            </div>
        </header>
        <div class="screen-body">
            <section class="screen-middle">
                <!-- 表盘实时温度 -->
                <div id="middle-top">
                    <!-- <div id="middle-top1"> -->
                    <div id="middle-top-1">
                        <dial></dial>
                    </div>
                    <div id="middle-top-1">
                        <dial1></dial1>
                    </div>
                    <div id="middle-top-1">
                        <dial2></dial2>
                    </div>
                </div>
                <!-- 出水进水柱状表 -->
                <div id="middle-zj">
                        <div id="middle-zj-1" >
                        <lssy ></lssy>
                    </div>
                        <div id="middle-zj-1" >
                            <lssy1 ></lssy1>
                    </div>
                         <div id="middle-zj-1" >
                        <lssy2 ></lssy2>
                    </div>
                </div>
                <!-- 折线时间塌缩表 -->
                <div id="middle-bottom">
                    <realTime></realTime>
                </div>
            </section>
            <section class="screen-right">
                <div id="right-top">
                    <div id="right-top-1" style="text-align: center; font-size: 25px; line-height: 90px">
                        市内温度:{{ $globalConfig.data }}℃ 
                        <!-- 条件渲染院内温度部分 -->
                        <template v-if="responseData && responseData.sTemperature !== undefined && responseData.sTemperature !== null">
                            &nbsp;&nbsp;&nbsp;&nbsp; 院内温度{{responseData.sTemperature}}℃ 
                        </template>
                        <!-- 如果responseData不存在，可以显示提示信息
                        <template v-else>
                            &nbsp;&nbsp;&nbsp;&nbsp; 院内温度数据获取中...
                        </template> -->
                    </div>
                    <!-- 全部温度表格 -->
                    <div id="right-top-2" style="display: flex; justify-content: center; align-items: center;">
                        <allEnvironments1 style="width: 100%; height: 100%;"></allEnvironments1>
                    </div>
                </div>
                <!-- 警报表格 -->
                <div id="right-bottom"  style="display: flex; justify-content: center; align-items: center;">
                    <marn style="width: 100%; height: 100%;"></marn>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import dial from "@/components/dial.vue";
import dial1 from "@/components/dial1.vue";
import dial2 from "@/components/dial2.vue";
import lssy from "@/components/lssy.vue";
import lssy1 from "@/components/lssy1.vue";
import lssy2 from "@/components/lssy2.vue";
import marn from "@/components/warn";
import realTime from "@/components/realTime";
import allEnvironments1 from "@/components/allEnvironments1.vue";
import axios from 'axios';
import Vue from 'vue'

export default {
    data() {
        return {
            formattedTime: null,
            sstq: null,
            timerId: null,
            timerIdw: null,
            responseData: null,  // 初始化为null，表示数据不存在
            ab: {
                show: 1
            },
            ab1: {
                show: 2
            },
        };
    },
    mounted() {
        this.time();
        this.startInterver();
        this.getData()
    },
    destroyed() {
        clearInterval(this.timerId);
        clearInterval(this.timerIdw);
    },
    methods: {
        // 获取实时时间
        time() {
            const now = new Date();
            const year = now.getFullYear();
            const month = ("0" + (now.getMonth() + 1)).slice(-2);
            const day = ("0" + now.getDate()).slice(-2);
            const hours = ("0" + now.getHours()).slice(-2);
            const minutes = ("0" + now.getMinutes()).slice(-2);
            const seconds = ("0" + now.getSeconds()).slice(-2);
            this.formattedTime =
                year +
                "年" +
                month +
                "月" +
                day +
                "日" +
                hours +
                ":" +
                minutes +
                ":" +
                seconds;
        },
        startInterver() {
            // 预先判断定时器是否清除，存在消除1
            if (this.timerId) {
                clearInterval(this.timerId);
                clearInterval(this.timerIdw);
            }
            this.timerId = setInterval(() => {
                this.time();
                this.getData();
            }, 1000);
            this.timerIdw = setInterval(() => {
                
            }, 3000000);
        },
        async getData() {
            try {
                const { data: ret } = await this.$http.get("sensor/getTemperature");
                // 查找sId为109的数据
                const data = ret.find(user => Number(user.sId) === 109);
                
                // 如果找到了数据，赋值给responseData
                if (data) {
                    this.responseData = data;
                } else {
                    // 如果没有找到，设置为null
                    this.responseData = null;
                }
            } catch (error) {
                console.error('获取温度数据失败:', error);
                // 请求失败时，清除数据
                this.responseData = null;
            }
        },
        
    },
    components: {
        dial,
        dial1,
        dial2,
        lssy,
        lssy1,
        lssy2,
        realTime: realTime,
        marn,
        allEnvironments1,
    },
};
</script>

<style lang="less" scoped>
.screen-container {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    background-color: #161522;
    color: #fff;
    box-sizing: border-box;
}

.screen-header {
    width: 100%;
    height: 64px;
    font-size: 20px;
    position: relative;

    >div {
        img {
            width: 100%;
        }
    }

    .title {
        position: absolute;
        left: 50%;
        top: 50%;
        font-size: 46px;
        transform: translate(-50%, -50%);
    }

    .title-right {
        display: flex;
        align-items: center;
        position: absolute;
        right: 0px;
        top: 50px;
        transform: translateY(-80%);
    }

    .qiehuan {
        width: 28px;
        height: 21px;
        cursor: pointer;
    }

    .datetime {
        font-size: 15px;
        margin-left: 10px;
    }

    .logo {
        position: absolute;
        left: 0px;
        top: 90%;
        transform: translateY(-80%);
        img {
            height: 60px;
            width: 200px;
        }
    }
}


/* 光晕效果 */
.screen-header::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 50% 0%, rgba(0, 119, 255, 0.15), transparent 60%);
    pointer-events: none;
}

.title {
    font-size: 26px;
    font-weight: 700;
    letter-spacing: 2px;
    background: linear-gradient(45deg, #00f2fe, #00ffea);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    text-shadow: 0 0 15px rgba(0, 242, 254, 0.4);
    position: relative;
    animation: titleGlow 3s ease-in-out infinite;
}



.screen-body {
    width: 100%;
    height: 100%;
    display: flex;
    margin-top: 10px;

    .screen-middle {
        height: 100%;
        width: 80%;
        margin-left: 1.6px;
        margin-right: 1.6px;

        #middle-top {
            width: 100%;
            height: 21.2%;
            display: flex;

            #middle-top-1 {
                display: flex;
                width: 33.3%;
                height: 100%;
                margin-left: 1.6px;
                border: 1px solid #607b8b;
            }
        }

        #middle-zj {
            width: 100%;
            height: 30%;
            margin-top: 25px;
            display: flex;

            #middle-zj-1 {
                width: 33.3%;
                height: 100%;
                border: 1px solid #607b8b;
                margin-left: 1.6px;
            }
        }

        #middle-bottom {
            margin-top: 25px;
            width: 100%;
            height: 30%;
        }
    }

    .screen-right {
        height: 100%;
        width: 27.6%;

        #right-top {
            height: 46%;

            #right-top-1 {
                height: 20%;
                border: 1px solid #607b8b;
            }

            #right-top-2 {
                height: 80%;
                border: 1px solid #607b8b;
            }
        }

        #right-bottom {
            height: 40.65%;
        }
    }
}

section>div {
    border: 1px solid #607b8b;
}
</style>